import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Box } from 'fw/components'
import CodeTable from './CodeTable';
import * as Formatting from 'fw/misc/Formatting'
import * as Parsing from 'fw/misc/Parsing'
import * as Items from './Items'

const Coding = () => (
    <React.Fragment>
        <ContentHeader title="Coding" description="Code functions to do various things">
        </ContentHeader>
        <ContentBody>
            <Row>
                <Col md={3}>
                    <Box title="Formatting - Currency">
                        <CodeTable items={Items.currency} function={Formatting.formatCurrency} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Decimal">
                        <CodeTable items={Items.decimal} function={Formatting.formatDecimal} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Decimal (4)">
                        <CodeTable items={Items.decimal4} function={(d) => { return Formatting.formatDecimal(d, 4) }} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Int">
                        <CodeTable items={Items.int} function={Formatting.formatInt} />
                    </Box>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Box title="Formatting - Precent">
                        <CodeTable items={Items.percent} function={Formatting.formatPrct} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Date">
                        <CodeTable items={Items.dateTime} function={Formatting.formatDate} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Date Time">
                        <CodeTable items={Items.dateTime} function={Formatting.formatDateTime} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Formatting - Client Date Time">
                        <CodeTable items={Items.dateTime} function={Formatting.formatClientDateTime} />
                    </Box>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Box title="Parsing - Currency">
                        <CodeTable items={Items.currency} function={Parsing.parseCurrency} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Parsing - Decimal">
                        <CodeTable items={Items.decimal} function={Parsing.parseDecimal} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Parsing - Int">
                        <CodeTable items={Items.int} function={Parsing.parseInt} />
                    </Box>
                </Col>
                <Col md={3}>
                    <Box title="Parsing - Percent">
                        <CodeTable items={Items.percent} function={Parsing.parsePrct} />
                    </Box>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Box title="Parsing - Dates">
                        <CodeTable items={Items.dateTime} function={Parsing.parseDate} />
                    </Box>
                </Col>
            </Row>
        </ContentBody>
    </React.Fragment>
)

export default Coding;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Coding/index.js